// TODO: Add unit tests

import { AdGender, GOOGLETAG_GENDER_VALUE_KEY } from 'constants/ads'

type YieldBirdOptimizationScript = {
  targetingValue: (targetingValueName: string) => string
  dool: boolean
}

export function yieldbirdOptimization() {
  const { targetingValue }: YieldBirdOptimizationScript = {
    targetingValue(name: string) {
      switch (name) {
        case 'bm':
          return Math.random() >= 0.1 ? '1' : '0'
        case 'ab':
          return targetingValue.dool ? 'b' : `a${Math.floor(Math.random() * 10)}`
        case 'dc':
          return targetingValue.dool ? 'd' : `c${Math.floor(Math.random() * 20)}`
        case 'mx':
          return targetingValue.dool ? `m${Math.floor(Math.random() * 180)}` : 'x'
        case 'tt':
          return `tt${Math.floor(Math.random() * 10)}`
        default:
          return ''
      }
    },
    dool: Math.random() >= 0.1,
  }

  const date = new Date()
  const minute = date.getUTCMinutes()
  let hour = date.getUTCHours() - 8
  let day = date.getUTCDay()

  if (hour < 0) {
    hour += 24
    day -= 1
  }

  if (day < 0) {
    day += 7
  }

  window.googletag.cmd.push(() => {
    window.googletag.pubads().setTargeting('yb_bm', targetingValue('bm'))
    window.googletag.pubads().setTargeting('yb_ab', targetingValue('ab'))
    window.googletag.pubads().setTargeting('yb_dc', targetingValue('dc'))
    window.googletag.pubads().setTargeting('yb_mx', targetingValue('mx'))
    window.googletag.pubads().setTargeting('yb_tt', targetingValue('tt'))
    window.googletag.pubads().setTargeting('yb_ff', `${Math.round(Math.random())}`)
    window.googletag.pubads().setTargeting('yb_tm', minute.toString())
    window.googletag.pubads().setTargeting('yb_th', hour.toString())
    window.googletag.pubads().setTargeting('yb_wd', day.toString())
  })
}

export function initGoogletag() {
  window.googletag = window.googletag || { cmd: [] }
}

export function seNonPersonalizedAds(nonPersonalizedAds: boolean) {
  window.googletag.cmd.push(() => {
    window.googletag.pubads().setPrivacySettings({ nonPersonalizedAds })
  })
}

export function setAdsGenderValue(genderValue?: AdGender | null) {
  if (!genderValue) return

  window.googletag.cmd.push(() => {
    window.googletag.pubads().setTargeting(GOOGLETAG_GENDER_VALUE_KEY, genderValue)
  })
}

export function setAdsSegments(adsSegmentIds: Array<number>) {
  if (!adsSegmentIds.length) return

  window.googletag.cmd.push(() => {
    adsSegmentIds.forEach(adsSegmentId =>
      window.googletag.pubads().setTargeting(`adus_${adsSegmentId}`, '1'),
    )
  })
}

export function setupGoogletagServices() {
  window.googletag.cmd.push(() => {
    window.googletag.pubads().enableSingleRequest()
    window.googletag.pubads().disableInitialLoad()
    window.googletag.pubads().collapseEmptyDivs()

    yieldbirdOptimization()

    window.googletag.enableServices()
  })
}
